
import React from 'react';
import { Box, Typography, IconButton, TextField } from '@mui/material';
import Header from './Header';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useTranslation } from 'react-i18next';

function SmartXIntegration({ user, children }) {

    const { t } = useTranslation();

    const apiURL = process.env.REACT_APP_API_BASE_URL_PROD;
    const clickNotificationURL = `${apiURL}/click/${user?.notificationId}`;
    const clickScriptURL = `${apiURL}/static/click-tracker.js`;
    const clickURL = `<script src="${clickScriptURL}" data-origin-url="${clickNotificationURL}"></script>`

    return (
            <Box
                sx={{
                    position: { xs: 'relative', md: 'absolute'},
                    top: { xs: '30%', md: '50%' },
                    left: { xs: '44%', md: '50%' },
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '100%', md: 540 },
                    bgcolor: 'background.paper',
                    boxShadow: 2,
                    p: { xs: 1, sm: 4 },
                    borderRadius: 1,
                }}
            >
            <Header text="Configuração"/>
            <Typography 
                id="modal-title" 
                variant="body" 
                component="h4" 
                gutterBottom 
                sx={{ margin: 1 }}
            >
                {t('modal_config.title')}
            </Typography>
            <Typography id="modal-title" variant="body" component="body" gutterBottom sx={{ margin: 1 }}>
                {t('modal_config.description')}
            </Typography>
            <TextField
                fullWidth
                sx={{ marginTop: 1 }}
                value={clickURL}
                InputProps={{
                    readOnly: true,
                    endAdornment: (
                        <IconButton onClick={() => navigator.clipboard.writeText(clickURL)}>
                        <ContentCopyIcon />
                        </IconButton>
                    ),
                }}
            />
            {/* Child components render here */}
            {children}
            </Box>
    );
}

export default SmartXIntegration;